module.exports = __webpack_public_path__ + "img/12.da751e03.jpg";